import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, CreditCard } from 'lucide-react';
import { servicesMenu } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A1F44] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2 space-y-4">
            <img 
              src="/assets/img/brand/logo-light.png" 
              alt="Trademark Liberty" 
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              Safeguarding Innovation. Protecting Identity. Your trusted partner in intellectual property law.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-2 pt-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-1" />
                <span className="text-gray-400 text-sm">123 Liberty Street, Suite 500<br />New York, NY 10006</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <span className="text-gray-400 text-sm">+1 (646) 687-2501</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <span className="text-gray-400 text-sm">info@trademarkliberty.com</span>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex space-x-3 pt-4">
              <a href="#" className="w-9 h-9 bg-[#D4AF37] hover:bg-[#B8941F] rounded-full flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-4 h-4 text-[#0A1F44]" />
              </a>
              <a href="#" className="w-9 h-9 bg-[#D4AF37] hover:bg-[#B8941F] rounded-full flex items-center justify-center transition-colors duration-200">
                <Twitter className="w-4 h-4 text-[#0A1F44]" />
              </a>
              <a href="#" className="w-9 h-9 bg-[#D4AF37] hover:bg-[#B8941F] rounded-full flex items-center justify-center transition-colors duration-200">
                <Linkedin className="w-4 h-4 text-[#0A1F44]" />
              </a>
              <a href="#" className="w-9 h-9 bg-[#D4AF37] hover:bg-[#B8941F] rounded-full flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-4 h-4 text-[#0A1F44]" />
              </a>
            </div>
          </div>

          {/* Services Columns - Dynamic from servicesMenu */}
          {servicesMenu.map((category) => (
            <div key={category.id}>
              <h4 className="text-sm font-bold mb-4 text-[#D4AF37] uppercase tracking-wider">{category.name}</h4>
              <ul className="space-y-2">
                {category.subServices.map((service, index) => (
                  <li key={index}>
                    <a 
                      href={service.link} 
                      className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm"
                    >
                      {service.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Payment Methods & Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            {/* Left: Copyright */}
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {currentYear} Trademark Liberty. All rights reserved.
              </p>
            </div>

            {/* Center: Secured Payment */}
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center space-x-2 text-gray-400">
                <CreditCard className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-xs font-semibold uppercase tracking-wide">Secured Payment</span>
              </div>
              <div className="flex items-center space-x-4">
                {/* Visa */}
                <img 
                  src="https://customer-assets.emergentagent.com/job_9829285a-4e8d-43c1-8aa4-dfba5e9e8459/artifacts/lioz0blv_visa_inc_logo.svg.png" 
                  alt="Visa" 
                  className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
                {/* Mastercard */}
                <img 
                  src="https://customer-assets.emergentagent.com/job_9829285a-4e8d-43c1-8aa4-dfba5e9e8459/artifacts/nxa3u9j1_Mastercard.png" 
                  alt="Mastercard" 
                  className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
                {/* American Express */}
                <img 
                  src="https://customer-assets.emergentagent.com/job_9829285a-4e8d-43c1-8aa4-dfba5e9e8459/artifacts/arzc9wj7_American%20Express.png" 
                  alt="American Express" 
                  className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
                {/* Discover */}
                <img 
                  src="https://customer-assets.emergentagent.com/job_9829285a-4e8d-43c1-8aa4-dfba5e9e8459/artifacts/i61v5gii_Discover.png" 
                  alt="Discover" 
                  className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              </div>
            </div>

            {/* Right: Links */}
            <div className="flex space-x-6 text-sm text-center md:text-right">
              <a href="/privacy" className="text-gray-400 hover:text-[#D4AF37] transition-colors">Privacy Policy</a>
              <a href="/terms" className="text-gray-400 hover:text-[#D4AF37] transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};